import { styled } from "@mui/material";
import TableCell from "@mui/material/TableCell";

export const TableCellStyled = styled(TableCell)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
